var map = {
	"./brands.fa.svg": [
		668,
		7
	],
	"./duotone.fa.svg": [
		669,
		8
	],
	"./light.fa.svg": [
		670,
		9
	],
	"./regular.fa.svg": [
		671,
		10
	],
	"./solid.fa.svg": [
		672,
		11
	],
	"./thin.fa.svg": [
		673,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 397;
module.exports = webpackAsyncContext;